import React, { useState, useEffect, useRef } from 'react'
import ImageIcon from '@mui/icons-material/Image'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
// import TableBody from '@mui/material/TableBody'
// import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Typography from '@mui/material/Typography'
import InputBase from '@mui/material/InputBase'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import { getRoleUserIdFromToken, toBase64 } from '../utils'
import AppBar from '../components/app-bar'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { CircularProgress, Button, Dialog, DialogTitle, DialogActions, AccordionDetails, makeStyles, Select, TextField } from '@material-ui/core'
import { customTheme } from '../styling'
import axios from '../axios'
import moment from 'moment'
import GeneralError from '../components/error'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import { Divider, List, ListItem, ListItemText, MenuItem, Popover, Tab, Tabs } from '@mui/material'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import LogoAfr from '../images/logo-afr.svg'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'



const Spec = ({ label, value }) => (
  <Box>
    <Typography fontSize=".8rem" color="text.secondary">
      {label}:
    </Typography>
    <Typography fontWeight="bold">{value}</Typography>
  </Box>
)

const useStyles = makeStyles((theme) => ({
    generateCodeContainer: {
        width: '100%',
        marginTop: '1.5rem',
    },
    appBarSpacer: theme.mixins.toolbar,
    uploadFile: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginLeft: '1rem',
        width: '90%',
        height: '20vh',
        display: 'flex',
        textAlign: 'center',
        border: `1px solid ${customTheme.colors.ui.grey}`,
        borderStyle: 'dotted',
        marginBottom: '0.3rem'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'hidden',
        overflowX: 'auto'
    },
    title: {
        color: 'black',
        
    },
    selectBoxMain: {
        width: '80vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        position: 'absolute',
        top: '40%',
        cursor: 'pointer'
    },
    selectBox: {
        width: '35%',
        backgroundColor: customTheme.colors.ui.ligthBlue,
        padding: '1.5rem 3.5rem',
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
            opacity: '0.8'
        },
    },
    loadingContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    formControl: {
        minWidth: 300, marginRight: '1.5rem'
    },
    dialogActions: {
        marginTop: '1rem'
    },
    contentContainer: {
        padding: '2rem'
    },
    textarea: {
        fontSize: '1rem',
        border: '1px solid #000',
        paddingLeft: '0.5rem',
        paddingTop: '0.5rem',
        resize: 'none',
        width: '100%',
        borderRadius: '8px',
        height: '30vh',
        '&:focus': {
            outline: 'none !important',
            outlineColor: customTheme.colors.ui.grey,
            border: `1px solid ${customTheme.colors.ui.grey} !important`
        },
    },

}))



const rows = []



const headCells = [
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Prodotto',
    },
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'Descrizione breve',
    },
    {
        id: 'unit',
        numeric: false,
        disablePadding: false,
        label: 'Unità disponibili',
    },
    {
        id: 'price',
        numeric: false,
        disablePadding: false,
        label: 'Prezzo',
    },
    {
        id: 'dateOfOrdine',
        numeric: false,
        disablePadding: false,
        label: 'Data creazione',
    },
]

function Item(props) {
    const { sx, ...other } = props;
    return (
        <Box
            sx={[
                (theme) => ({
                    bgcolor: '#fff',
                    color: 'grey.800',
                    border: '1px solid',
                    borderColor: 'grey.300',
                    p: 1,
                    m: 1,
                    borderRadius: 2,
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    ...theme.applyStyles('dark', {
                        bgcolor: '#101010',
                        color: 'grey.300',
                        borderColor: 'grey.800',
                    }),
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...other}
        />
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const HoverButton = ({ product, onClick }) => {
  const [isHover, setIsHover] = React.useState(false);

  return (
    <Button
      variant="outlined"
      fullWidth
      style={{
        marginTop:'auto' ,
        // marginTop: '1rem',
        borderColor: customTheme.colors.ui.green,
        color: isHover ? '#fff' : customTheme.colors.ui.green,
        fontWeight: 'bold',
        borderRadius: '8px',
        backgroundColor: isHover ? customTheme.colors.ui.green : 'transparent',
        boxShadow: isHover ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : 'none',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onClick(product)}
    >
      Modifica prodotto
    </Button>
  );
};


const Dashboard = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [addProductOpen, setAddProductOpen] = useState(false)
    const [description, setDescription] = useState(null)
    const [instructions, setInstructions] = useState(null)
    const [products, setProducts] = useState([])
    const [nameProduct, setNameProduct] = useState(null)
    const inputRef = useRef(null)
    const [productTypes, setProductTypes] = useState([{ id: 0, description: 'Tutti i prodotti' }]);
    const [productOpen, setProductOpen] = useState(null)
    const [price, setPrice] = useState(null)
    const classes = useStyles()
    const { enqueueSnackbar } = SnackBar.Consumer()
    const [currentInputSearch, setCurrentInputSearch] = useState('')
    const [category, setCategory] = useState(0);
    const [addCategory, setAddCategory] = useState(1)
    const [orderTotal, setOrderTotal] = useState([])
    const [productsChart, setProductsChart] = useState([])
    const [files, setFiles] = useState([])
    const [creatingProduct, setCreatingProduct] = useState(false)
    const [code, setCode] = useState(null)
    const [pieceWeight, setPieceWeight] = useState(null)
    const [pieceSlice, setPieceSlice] = useState(null)
    const [piecePerCarton, setPiecePerCarton] = useState(null)
    const [weight, setWeight] = useState(null)
    const [cartonSlice, setCartonSlice] = useState(null)
    const [cartoniPerStrato, setCartoniPerStrato] = useState(null)
    const [stratiPerPallet, setStratiPerPallet] = useState(null)
    const [cartonSlicePerPallet, setCartonSlicePerPallet] = useState(null)
    const [minOrderCarton, setMinOrderCarton] = useState(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [currentProductId, setCurrentProductId] = useState(null)
    const first = 6
    const [after, setAfter] = useState(0)
    const [hasNextPage, setHasNextPage] = useState(false)
    const [deletingProduct, setDeletingProduct] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const roleUserId = getRoleUserIdFromToken()
    const [deactivedProduct, setDeactivedProduct] = useState(null)
    const [delisting, setDelisting] = useState(false)
    const [productDeletePopup, setProductDeletePopup] = useState(false)

    // Lógica para campo de peso com vírgula e 3 casas decimais
    const [weightDigits, setWeightDigits] = React.useState(''); // só dígitos, ex: "1111"
    const [weightDisplay, setWeightDisplay] = React.useState(''); // ex: "1,111"

    const formatFromDigits = (rawDigits) => {
    if (!rawDigits) return '';
    // remove zeros à esquerda (mas deixamos no mínimo 1 dígito para formatação)
    rawDigits = rawDigits.replace(/^0+/, '');
    // se ficou vazio, consideramos "0"
    if (rawDigits === '') rawDigits = '0';

    // garantimos pelo menos 4 dígitos para simplificar a lógica (1 inteiros + 3 decimais)
    while (rawDigits.length < 4) {
        rawDigits = '0' + rawDigits;
    }

    const intPart = rawDigits.slice(0, rawDigits.length - 3).replace(/^0+(?=\d)/, '') || '0';
    const decPart = rawDigits.slice(-3);
    return `${intPart},${decPart}`;
    };

    const handleDigitKey = (digit) => {
    // limite de dígitos (opcional) — aqui por exemplo 7 dígitos totais (p.ex 9999,999)
    const MAX_DIGITS = 7;
    let next = (weightDigits + digit).replace(/^0+/, ''); // evita muitos zeros à esquerda
    if (next.length > MAX_DIGITS) next = next.slice(-MAX_DIGITS);
    setWeightDigits(next);
    setWeightDisplay(formatFromDigits(next));
    };

    const handleBackspace = () => {
    const next = weightDigits.slice(0, -1);
    setWeightDigits(next);
    setWeightDisplay(formatFromDigits(next));
    };

    const handleClear = () => {
    setWeightDigits('');
    setWeightDisplay('');
    };

    const handlePaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    const digits = paste.replace(/\D/g, '');
    if (!digits) return;
    // vamos concatenar e truncar se necessário
    const MAX_DIGITS = 7;
    let next = (weightDigits + digits).replace(/^0+/, '');
    if (next.length > MAX_DIGITS) next = next.slice(-MAX_DIGITS);
    setWeightDigits(next);
    setWeightDisplay(formatFromDigits(next));
    };


    const setWeightField = (value) => {
    if (value == null || value === '') {
        setWeight(null);
        setWeightDigits('');
        setWeightDisplay('');
        return;
    }

    const numeric = Number(value);
    if (Number.isNaN(numeric)) {
        setWeight(null);
        setWeightDigits('');
        setWeightDisplay('');
        return;
    }

    const digits = Math.round(numeric * 1000).toString(); // ex.: 4.25 -> "4250"
    setWeight(numeric);
    setWeightDigits(digits);
    setWeightDisplay(formatFromDigits(digits));
    };

    
    const getProducts = async (input = null, afterQuery = 0) => {
        let url
        if (input) {
            url = `/get-list-products?typeId=${category}&first=${first}&after=${afterQuery}&search=${input}`
        } else {
            url = `/get-list-products?typeId=${category}&first=${first}&after=${afterQuery}`
        }
        const products = await axios.get(url)

        return products.data
    }

    const getProductTypes = async () => {
        let url = '/get-list-product-types'

        const productTypes = await axios.get(url)
        return productTypes.data
    }

    const getInitialData = async () => {
        const products = await getProducts()
        const productTypes = await getProductTypes()
        return { products, productTypes }
    }

    useEffect(() => {
        setLoading(true)
        getInitialData().then((res) => {
            setHasNextPage(res.products.hasNextPage)
            setProducts(res.products.listProducts)
            setProductTypes([{ description: "Tutti i prodotti", id: 0 }, ...res.productTypes])
        }).catch((error) => {
            console.log(error)
            setError(true)
        }).finally(() => {
            setLoading(false)
        })
    }, [category])


    const handleSave = async () => {
        let fileBase64;
        try {
            fileBase64 = files.length > 0 && await toBase64(files[0])
        } catch (error) {
            fileBase64 = null
        }

        const weightValue = weightDigits
        ? Number.parseFloat(weightDigits) / 1000
        : null;

        const body = {
            name: nameProduct,
            instructions,
            description,
            code,
            pieceWeight,
            pieceSlice,
            weight: weightValue,
            piecePerCarton: piecePerCarton ? parseInt(piecePerCarton, 10) : null,
            cartoniPerStrato: cartoniPerStrato ? Number(cartoniPerStrato) : null,
            stratiPerPallet: stratiPerPallet ? Number(stratiPerPallet) : null,
            cartonSlice,
            cartonSlicePerPallet,
            addCategory,
            price,
            minOrderCarton,
            fileBase64,
            typeId: addCategory,
            imageUrl,
            }
        if (currentProductId) {
            body.id = currentProductId
        }
        setCreatingProduct(true)
        axios.post(`/create-product`, body).then(() => {
            setDescription(null)
            setInstructions(null)
            setNameProduct(null)
            setPrice(null)
            setCode(null)
            setPieceWeight(null)
            setPieceSlice(null)
            setWeight(null)
            setWeightDigits('');
            setWeightDisplay('');
            setPiecePerCarton(null)
            setMinOrderCarton(null)
            setCartoniPerStrato(null)
            setStratiPerPallet(null)
            setFiles([])
            setCartonSlice(null)
            setCartonSlicePerPallet(null)
            setAddCategory(1)
            setAddProductOpen(false)
            setCurrentProductId(null)
            setLoading(true)
            enqueueSnackbar({ variant: 'success', message: currentProductId ? 'Prodotto salvato correttamente' : 'Prodotto creato correttamente' })
            getInitialData().then((res) => {
                setProducts(res.products.listProducts)
            }).catch((error) => {
                setError(true)
            }).finally(() => {
                setLoading(false)
            })

        }).catch((error) => {
            console.log(error)
            enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
        }).finally(() => {
            setCreatingProduct(false)
        })
    }






    const handleInputSearchChange = (event) => {
        setCurrentInputSearch(event.target.value)
    }

    const handleSearchProducts = () => {
        setAfter(0)
        setLoading(true)
        getProducts(currentInputSearch).then((res) => {
            setHasNextPage(res.hasNextPage)
            setProducts(res.listProducts)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })

        })
    }

    const handleClearInput = () => {
        setAfter(0)
        setCurrentInputSearch('')
        getProducts('').then((res) => {
            setHasNextPage(res.hasNextPage)
            setProducts(res.listProducts)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })

        })
    }

    const handleClickFileUpload = (e) => {

        e.preventDefault()

        if (!inputRef || !inputRef.current) return

        inputRef.current.click()
    }

    const handleFileUpload = (e) => {
        const filesRaw = e.target.files
        if (!filesRaw) return

        const file = filesRaw[0]
        setFiles([file, ...files])
        // setFilesDisplay([{ name: file.name }, ...filesDisplay])

    }

    const handleFetchMore = () => {
        setLoadingMore(true)
        setAfter(after + 6)
        getProducts(currentInputSearch, after + 6).then((res) => {
            setLoadingMore(false)
            setHasNextPage(res.hasNextPage)
            setProducts([...products, ...res.listProducts])
        }).catch(() => {
            setLoadingMore(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })
        })
    }

    const handleCloseModal = () => {
        setCurrentProductId(null)
        setDescription(null)
        setInstructions(null)
        setNameProduct(null)
        setPrice(null)
        setCode(null)
        setPieceWeight(null)
        setPieceSlice(null)
        setWeight(null)
        setWeightDigits('');
        setWeightDisplay('');
        setPiecePerCarton(null)
        setCartoniPerStrato(null)
        setStratiPerPallet(null)
        setMinOrderCarton(null)
        setFiles([])
        setCartonSlice(null)
        setCartonSlicePerPallet(null)
        setAddCategory(1)
        setAddProductOpen(false)
    }


    const handleDeleteProduct = async () => {
        setDeletingProduct(true)
        axios.post(`/delete-product`, { id: currentProductId }).then(() => {
            setDeletingProduct(false)
            handleCloseModal()
            enqueueSnackbar({ variant: 'success', message: 'Prodotto eliminato correttamente' })
            setLoading(true)
            getProducts('').then((res) => {
                setHasNextPage(res.hasNextPage)
                setProducts(res.listProducts)
                setLoading(false)
            }).catch(() => {
                setLoading(false)
                enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                    variant: 'error',
                })

            })
        }).catch((error) => {
            enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
        })
    }

    const handleActiveProduct = async (product) => {
        setProducts(products.filter(({ id }) => id !== product.id))
        setLoading(true)
        await axios.post('/update-product', { id: product.id, active: 1 })
        getProducts('').then((res) => {
            setHasNextPage(res.hasNextPage)
            setProducts(res.listProducts)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })

        })


    }
    const handleDeactiveProduct = async (product) => {
        setProducts(products.filter(({ id }) => id !== product.id))
        setDelisting(true)
        await axios.post('/update-product', { id: product.id, active: 0 })

        getProducts('').then((res) => {
            setHasNextPage(res.hasNextPage)
            setProducts(res.listProducts)
            setDelisting(false)
            setDeactivedProduct(null)
        }).catch(() => {
            setDelisting(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })

        })


    }

    

    

    return (
        <AppBar>


            {error ? <GeneralError /> : loading ?
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Typography className={classes.title} variant="h5" gutterBottom component="h2">
                        Catalogo Prodotti
                    </Typography>

                    <Box className={classes.loadingContainer}>
                        <CircularProgress />
                    </Box>
                </main>
                :
                <main className={classes.content}>
                    <>
                        <div className={classes.appBarSpacer} />

                        <Typography style={{ float: 'left' }} className={classes.title} variant="h5" gutterBottom component="h2">
                            Catalogo Prodotti
                        </Typography>

                        {productOpen && <Dialog
                            fullWidth={true}
                            maxWidth="md"
                            className={classes.dialogContainer}
                            open={productOpen}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <CloseIcon onClick={() => setProductOpen(null)} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
                            <Box className={classes.contentContainer}>
                                <Box>
                                    <Box style={{ display: 'flex', flexDirection: 'row'}}>
                                        <img src={productOpen?.productImage ?? LogoAfr} style={{ width: '320px' }} />
                                        <Box style={{ display: 'flex', flexDirection: 'column', marginLeft: '2rem' }}>
                                            <Typography style={{ fontWeight: 'bold' }}>{productOpen?.name}</Typography>
                                            <Typography style={{ marginTop: '0.5rem' }}>{productOpen?.description}</Typography>
                                            <Typography style={{ fontWeight: 'bold', marginTop: '2rem' }}>Modalità d'uso:</Typography>
                                            <Typography style={{  marginTop: '0.5rem'  }}>{productOpen.instructions}</Typography>
                                        </Box>


                                    </Box>






                                </Box>


                            </Box>
                        </Dialog>
                        }

                        {deactivedProduct && <Dialog open={deactivedProduct}>
                            <CloseIcon onClick={() => setDeactivedProduct(false)} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}}  />
                            
                                <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
                                <List>
                                    <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Box style={{ width: '25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                        <Typography>Sei sicuro di voler delistare questo prodotto?</Typography>

                                        <Box display={'flex'} flexDirection={'row'}>
                                        <Button onClick={() => {
                                            setDeactivedProduct(false)
                                        }} style={{ marginTop: '1rem', width: '6rem', marginRight: '1rem' }} variant='contained' color='default'>{'Annulla'}</Button>
                                        <Button onClick={() => handleDeactiveProduct(deactivedProduct)} style={{ marginTop: '1rem', width: '6rem', backgroundColor: customTheme.colors.ui.red, color: 'white' }} variant='contained'>{delisting ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Delista'}</Button>
                                        </Box>




                                    </Box>
                                    </ListItem>
                                </List>
                                </Box>
                            </Dialog>
                        }

                        {productDeletePopup && <Dialog open={productDeletePopup}>
                        <CloseIcon onClick={() => setProductDeletePopup(false)} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
                                <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
                                <List>
                                    <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Box style={{ width: '25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                        <Typography>Sei sicuro di voler eliminare questo prodotto?</Typography>

                                        <Box display={'flex'} flexDirection={'row'}>
                                        <Button onClick={() => {
                                            setProductDeletePopup(false)
                                        }} style={{ marginTop: '1rem', width: '6rem', marginRight: '1rem' }} variant='contained' color='default'>{'Annulla'}</Button>
                                        <Button onClick={() => handleDeleteProduct()} style={{ marginTop: '1rem', width: '6rem', backgroundColor: customTheme.colors.ui.red, color: 'white' }} variant='contained'>{deletingProduct ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Elimina'}</Button>
                                        </Box>




                                    </Box>
                                    </ListItem>
                                </List>
                                </Box>
                            </Dialog>
                        }

                        <Dialog
                            fullWidth
                            maxWidth="md"
                            className={classes.dialogContainer}
                            open={addProductOpen}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            >
                            <CloseIcon
                                onClick={handleCloseModal}
                                style={{ float: 'right', position: 'absolute', right: 10, top: 10, cursor: 'pointer' }}
                            />

                            <Box className={classes.contentContainer}>
                                <DialogTitle id="alert-dialog-title" className={classes.title}>
                                {currentProductId ? 'Modifica prodotto' : 'Aggiungi nuovo prodotto'}
                                </DialogTitle>

                                <div>
                                {/* Linha 1: imagem + nome */}
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Immagine del prodotto</AccordionDetails>
                                    <AccordionDetails>
                                        {files.length || imageUrl ? (
                                        <ListItemText
                                            style={{
                                            position: 'relative',
                                            bottom: '0.3rem',
                                            borderStyle: 'dotted',
                                            borderRadius: '6px',
                                            borderColor: 'grey',
                                            padding: '0.6rem',
                                            }}
                                        >
                                            <ImageIcon style={{ position: 'relative', top: '0.3rem', marginRight:'0.5rem' }} />
                                            {files.length
                                            ? files[0]?.name?.length > 30
                                                ? `${files[0].name.slice(0, 30)}...`
                                                : files[0].name
                                            : imageUrl.length > 30
                                                ? `${imageUrl.slice(0, 30)}...`
                                                : imageUrl}

                                            <CloseIcon
                                            onClick={() => {
                                                setImageUrl(null)
                                                setFiles([])
                                            }}
                                            style={{ float: 'right', cursor: 'pointer', position: 'relative', top: '0.3rem' }}
                                            />
                                        </ListItemText>
                                        ) : (
                                        <ListItemText
                                            onClick={handleClickFileUpload}
                                            style={{
                                            cursor: 'pointer',
                                            position: 'relative',
                                            bottom: '0.2rem',
                                            borderStyle: 'dotted',
                                            borderRadius: '6px',
                                            borderColor: 'grey',
                                            padding: '1rem',
                                            }}
                                            primary="Carica qui immagine prodotto"
                                        />
                                        )}
                                        <input
                                        accept="image/*"
                                        ref={inputRef}
                                        type="file"
                                        hidden
                                        onClick={(event) => {
                                            event.target.value = null
                                        }}
                                        onChange={handleFileUpload}
                                        />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Nome Prodotto</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        placeholder="Inserisci nome del prodotto"
                                        fullWidth
                                        variant="outlined"
                                        value={nameProduct}
                                        onChange={(event) => setNameProduct(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>
                                </Box>

                                {/* Linha 2: categoria + codice */}
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Categoria</AccordionDetails>
                                    <AccordionDetails>
                                        <Select
                                        fullWidth
                                        variant="outlined"
                                        value={addCategory}
                                        onChange={(event) => setAddCategory(event.target.value)}
                                        MenuProps={{
                                            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                            transformOrigin: { vertical: 'top', horizontal: 'left' },
                                            getContentAnchorEl: null,
                                        }}
                                        >
                                        {productTypes
                                            .filter(({ id }) => id !== 0)
                                            .map(({ id, description }) => (
                                            <MenuItem key={id} value={id}>
                                                {description}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Codice prodotto</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        type="text"
                                        placeholder="Inserisci codice prodotto"
                                        fullWidth
                                        variant="outlined"
                                        value={code}
                                        onChange={(event) => setCode(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>
                                </Box>

                                {/* Linha 3: pesos / confezione / nuovi campos / min ordine */}
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Peso unitario (g)</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                            type="number"
                                            // step="0.1"
                                            placeholder="Inserisci peso unitario in grammi"
                                            fullWidth
                                            variant="outlined"
                                            InputProps={{ inputProps: { min: 0 } }}
                                            value={pieceWeight}
                                            onChange={(event) => setPieceWeight(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Pezzi/Fette per confezione</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        type="number"
                                        placeholder="Inserisci n. pezzi/fette per confezione"
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={pieceSlice}
                                        onChange={(event) => setPieceSlice(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Peso cartone netto (kg)</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                            type="text" // importante: usar text para poder manipular o input livremente
                                            placeholder="Inserisci peso cartone in kg"
                                            fullWidth
                                            variant="outlined"
                                            inputProps={{
                                                inputMode: 'numeric', // sugere teclado numérico em mobiles
                                                pattern: '[0-9]*',
                                                autoComplete: 'off',
                                            }}
                                            value={weightDisplay}
                                            onKeyDown={(e) => {
                                                // controla digitação de dígitos e backspace/delete
                                                if (e.key === 'Backspace') {
                                                e.preventDefault();
                                                handleBackspace();
                                                return;
                                                }
                                                if (e.key === 'Delete') {
                                                e.preventDefault();
                                                handleClear();
                                                return;
                                                }
                                                // aceitar apenas teclas de 0-9
                                                if (/^[0-9]$/.test(e.key)) {
                                                e.preventDefault();
                                                handleDigitKey(e.key);
                                                return;
                                                }
                                                // permitir setas, tab, enter
                                                if (
                                                e.key === 'ArrowLeft' ||
                                                e.key === 'ArrowRight' ||
                                                e.key === 'Tab' ||
                                                e.key === 'Enter'
                                                ) {
                                                return;
                                                }
                                                // bloquear todo o resto
                                                e.preventDefault();
                                            }}
                                            onPaste={handlePaste}
                                            />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Confezioni per cartone</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        type="number"
                                        placeholder="Inserisci n. confezioni per cartone"
                                        fullWidth
                                        variant="outlined"
                                        step='1'
                                        InputProps={{ inputProps: { min: 0, step: 1 } }}
                                        value={piecePerCarton}
                                        onChange={(event) => setPiecePerCarton(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Cartoni per strato</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        type="number"
                                        placeholder="Inserisci n. cartoni per strato"
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={cartoniPerStrato}
                                        onChange={(event) => setCartoniPerStrato(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Strati per pallet</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        type="number"
                                        placeholder="Inserisci n. strati per pallet"
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={stratiPerPallet}
                                        onChange={(event) => setStratiPerPallet(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>

                                    <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Numero minimo ordine (crt)</AccordionDetails>
                                    <AccordionDetails>
                                        <TextField
                                        type="number"
                                        placeholder="Inserisci minimo ordine in cartoni"
                                        fullWidth
                                        variant="outlined"
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={minOrderCarton}
                                        onChange={(event) => setMinOrderCarton(event.target.value)}
                                        />
                                    </AccordionDetails>
                                    </Box>
                                </Box>

                                {/* Descrizione */}
                                <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Descrizione del prodotto</AccordionDetails>
                                    <AccordionDetails>
                                    <textarea
                                        className={classes.textarea}
                                        placeholder="Inserisci descrizione del prodotto"
                                        value={description ?? ''}
                                        onChange={(event) => setDescription(event.target.value)}
                                    />
                                    </AccordionDetails>
                                </Box>

                                {/* Istruzioni */}
                                <Box sx={{ fontSize: '1rem' }}>
                                    <AccordionDetails>Istruzioni</AccordionDetails>
                                    <AccordionDetails>
                                    <textarea
                                        className={classes.textarea}
                                        placeholder="Inserisci istruzioni"
                                        value={instructions ?? ''}
                                        onChange={(event) => setInstructions(event.target.value)}
                                    />
                                    </AccordionDetails>
                                </Box>
                                </div>

                                <DialogActions className={classes.dialogActions}>
                                <Button style={{ width: '12rem' }} onClick={handleCloseModal} variant="contained" color="default">
                                    Annulla
                                </Button>

                                {currentProductId && (
                                    <Button
                                        disabled={deletingProduct}
                                        style={{ width: '12rem', color: '#fff', backgroundColor: customTheme.colors.ui.red }}
                                        onClick={() => setProductDeletePopup(true)}
                                        variant="contained"
                                        >
                                            {deletingProduct ? <CircularProgress style={{ color: '#fff' }} size={22} /> : 'Elimina'}
                                    </Button>
                                )}

                                <Button style={{ width: '12rem' }} onClick={handleSave} variant="contained" color="primary">
                                    {creatingProduct ? <CircularProgress style={{ color: 'white' }} size={22} /> : currentProductId ? 'Salva prodotto' : 'Aggiungi prodotto'}
                                </Button>
                                </DialogActions>
                            </Box>

                            



                            
                        </Dialog>
                        
                        {roleUserId === 1 && <Button
                            type="submit"
                            fullWidth
                            variant="outlined"
                            style={{ height: '2.5rem', fontSize:'0.9rem', marginLeft: '1rem', float: 'right', width: '240px', color: customTheme.colors.ui.green, border: `1px solid ${customTheme.colors.ui.green}` }}
                            onClick={() => setAddProductOpen(true)}
                        >
                            Aggiungi un prodotto

                        </Button>
                        }

                        <Paper
                            component="form"
                            elevation={0}
                            sx={{
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                border: '1px solid',
                                borderColor: 'grey.400',
                                // borderRadius: 999,
                                pl: 1,
                                pr: .5,
                                width: 320,
                                float: 'right',
                            }}
                            >
                            <IconButton
                                size="small"
                                onClick={() => currentInputSearch && handleSearchProducts()}
                                sx={{ color: 'grey.700' }}
                            >
                                <SearchIcon fontSize="small" />
                            </IconButton>

                            <InputBase
                                value={currentInputSearch}
                                onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault()
                                    if (currentInputSearch) handleSearchProducts()
                                }
                                }}
                                onChange={handleInputSearchChange}
                                placeholder="Cerca …"
                                sx={{ flex: 1, fontSize: '0.95rem', ml: 1 }}
                                inputProps={{ 'aria-label': 'Cerca' }}
                            />

                            {currentInputSearch && (
                                <IconButton
                                size="small"
                                onClick={handleClearInput}
                                sx={{ color: 'grey.600' }}
                                >
                                <CloseIcon fontSize="small" />
                                </IconButton>
                            )}
                        </Paper>



                        <Select
                        
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                            style={{ height: '2.5rem', fontSize:'1rem', width: '200px', marginRight: '1rem', float: 'right', }}
                            fullWidth={true}
                            variant='outlined'
                            value={category}
                            onChange={(event) => setCategory(event.target.value)}
                        >
                            {productTypes.map(({ id, description }) => <MenuItem key={id} value={id}>{description}</MenuItem>)}

                        </Select>

                        {orderTotal.length > 0 && <Box style={{
                            float: 'right',
                            color: 'white',
                            position: 'relative',
                            left: '1rem',
                            bottom: '0.5rem',
                            height: orderTotal.reduce((acc, value) => acc + value.value, 0) >= 100 ? '28px' : '24px',
                            width: orderTotal.reduce((acc, value) => acc + value.value, 0) >= 100 ? '28px' : '24px',
                            backgroundColor: customTheme.colors.ui.green,
                            borderRadius: '50%',
                            display: 'block'

                        }}>
                            <Typography style={{
                                fontSize: orderTotal.reduce((acc, value) => acc + value.value, 0) >= 100 ? '0.8rem' : '0.9rem',
                                marginTop: orderTotal.reduce((acc, value) => acc + value.value, 0) >= 100 ? '0.25rem' : '0.1rem',
                                marginLeft: orderTotal.reduce((acc, value) => acc + value.value, 0) >= 10 ? '0.2rem' : '0.5rem'
                            }}>{orderTotal.reduce((acc, value) => acc + value.value, 0)}</Typography>
                        </Box>
                        }

                        <TableContainer style={{ marginTop: '4rem' }}>
                            <InfiniteScroll
                                height={'80vh'}
                                style={{ width: '100%' }}
                                dataLength={products.length}
                                next={handleFetchMore}
                                hasMore={hasNextPage}

                            >
                                
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0 }}>
                                    {products.map((product) => {
                                        const productsChartCurrent = productsChart.find(({ id }) => id === product.id)
                                        return (
                                            <Item
                                                key={product.id}
                                                style={{
                                                    padding: '1.5rem',
                                                    boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
                                                    borderRadius: '12px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '1rem',
                                                }}
                                                >
                                                <Box
                                                    sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                    }}
                                                >
                                                    <Button
                                                    size="small"
                                                    onClick={() => setProductOpen(product)}
                                                    style={{ textDecoration: 'underline', color: customTheme.colors.ui.blue }}
                                                    >
                                                    Dettagli
                                                    </Button>

                                                    {roleUserId === 1 && (
                                                    <Button
                                                        size="small"
                                                        onClick={() =>
                                                            product.active ? setDeactivedProduct(product) : handleActiveProduct(product)
                                                        }
                                                        style={{
                                                            textDecoration: 'underline',
                                                            color: product.active ? customTheme.colors.ui.red : customTheme.colors.ui.green,
                                                        }}
                                                        >
                                                        {product.active ? 'Delista' : 'Riattiva'}
                                                    </Button>
                                                    )}
                                                </Box>

                                                <Box sx={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
                                                    <img
                                                    src={product?.productImage ?? LogoAfr}
                                                    style={{ width: '160px', height: '120px', objectFit: 'cover', borderRadius: '8px',  }}
                                                    alt={product?.name}
                                                    />
                                                    <Box sx={{ display:'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between'}}>
                                                        <Typography fontWeight="bold" fontSize="1rem">
                                                            <strong>{product?.name}</strong>
                                                        </Typography>
                                                        <Typography fontSize=".9rem" color="text.secondary" sx={{ mt: 0.5 }}>
                                                            {product?.description?.length > 60
                                                            ? `${product?.description.slice(0, 60)}...`
                                                            : product?.description}
                                                        </Typography>
                                                        <Typography fontSize=".85rem" sx={{ mt: 1 }}>
                                                            Codice articolo: <strong>{product?.code}</strong>
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                
                                                {/* Card Infos */}
                                                <Box
                                                    sx={{
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))',
                                                    gap: '0.5rem 1rem',
                                                    borderTop: '1px solid #eee',
                                                    borderBottom: '1px solid #eee',
                                                    py: 1.5,
                                                    }}
                                                >
                                                    <Spec label="Peso unitario (g)" value={<strong>{product?.pieceWeight ?? '-'} g</strong>} />
                                                    <Spec label="Pezzi/Fette per confezione" 
                                                        value={
                                                            <strong>{product?.pieceSlice ?? '-'} pz</strong>
                                                        } 
                                                    />
                                                    <Spec label="Confezioni per cartone"
                                                        value={
                                                            <strong>{product?.piecePerCarton ?? '-'} conf</strong>
                                                        }
                                                    />
                                                    <Spec label="Peso cartone netto (kg)"
                                                        fontWeight="bold"
                                                        value={
                                                            <strong>{
                                                                    product?.weight != null
                                                                ? `${Number(product.weight).toFixed(3).replace('.', ',')} kg`
                                                                : '-'
                                                            }</strong>
                                                        }
                                                    />
                                                    
                                                    <Spec label="Cartoni per strato"
                                                        value={
                                                            <strong>{product?.cartoniPerStrato ?? product?.cartonSlice ?? '-'} ct</strong>
                                                        }
                                                    />
                                                    <Spec label="Strati per pallet"
                                                        value={
                                                            <strong>{product?.stratiPerPallet ?? product?.cartonSlicePerPallet ?? '-'} str</strong>
                                                        }
                                                    />
                                                    <Spec label="Min. ordine cartoni"
                                                        value={
                                                            <strong>{product?.minOrderCarton ?? '-'} ct</strong>
                                                        }
                                                    />
                                                </Box>

                                                <Box>
                                                    <Typography fontWeight="bold"><strong>Modalità d'uso</strong>:</Typography>
                                                    <Typography fontSize=".9rem" color="text.secondary">
                                                    {product?.instructions?.length > 100
                                                        ? `${product?.instructions.slice(0, 100)}...`
                                                        : product?.instructions || '-'}
                                                    </Typography>
                                                </Box>

                                                {roleUserId === 1 && (
                                                    // <Button
                                                    //     key={product.id}
                                                    //     variant="outlined"
                                                    //     fullWidth
                                                    //     style={{
                                                    //         borderColor: customTheme.colors.ui.green,
                                                    //         color: isHover ? '#fff' : customTheme.colors.ui.green,
                                                    //         fontWeight: 'bold',
                                                    //         borderRadius: '8px',
                                                    //         backgroundColor: isHover ? customTheme.colors.ui.green : 'transparent',
                                                    //         boxShadow: isHover ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : 'none',
                                                    //         transition: 'all 0.3s ease',
                                                    //         cursor: 'pointer',
                                                    //     }}
                                                    //     onMouseEnter={() => setIsHover(true)}
                                                    //     onMouseLeave={() => setIsHover(false)}
                                                    //     onClick={() => {
                                                    //         setDescription(product.description)
                                                    //         setInstructions(product.instructions)
                                                    //         setNameProduct(product.name)
                                                    //         setPrice(product.price)
                                                    //         setCode(product.code)
                                                    //         setPieceWeight(product.pieceWeight)
                                                    //         setPieceSlice(product.pieceSlice)
                                                    //         setWeight(product.weight)
                                                    //         setCartonSlice(product.cartonSlice)
                                                    //         setCartonSlicePerPallet(product.cartonSlicePerPallet)
                                                    //         setCartoniPerStrato(product.cartoniPerStrato)
                                                    //         setStratiPerPallet(product.stratiPerPallet)
                                                    //         setPiecePerCarton(product.piecePerCarton)
                                                    //         setMinOrderCarton(product.minOrderCarton)
                                                    //         setAddCategory(product?.typeId)
                                                    //         setAddProductOpen(true)
                                                    //         setImageUrl(product.imageUrl)
                                                    //         setCurrentProductId(product.id)
                                                    //     }}
                                                    //     >
                                                    //     Modifica prodotto
                                                    // </Button>
                                                    <HoverButton
                                                        key={product.id}
                                                        product={product}
                                                        onClick={(p) => {
                                                        setDescription(p.description)
                                                        setInstructions(p.instructions)
                                                        setNameProduct(p.name)
                                                        setPrice(p.price)
                                                        setCode(p.code)
                                                        setPieceWeight(p.pieceWeight)
                                                        setPieceSlice(p.pieceSlice)
                                                        // setWeight(p.weight)
                                                        setWeightField(p.weight);
                                                        setCartonSlice(p.cartonSlice)
                                                        setCartonSlicePerPallet(p.cartonSlicePerPallet)
                                                        setCartoniPerStrato(p.cartoniPerStrato)
                                                        setStratiPerPallet(p.stratiPerPallet)
                                                        setPiecePerCarton(p.piecePerCarton)
                                                        setMinOrderCarton(p.minOrderCarton)
                                                        setAddCategory(p?.typeId)
                                                        setAddProductOpen(true)
                                                        setImageUrl(p.imageUrl)
                                                        setCurrentProductId(p.id)
                                                        }}
                                                    />

                                                )}
                                            </Item>

                                        )
                                    })}




                                </Box>
                            

                            </InfiniteScroll>
                            {loadingMore && <h4 className={classes.loadingMessage}>Caricamento...</h4>}
                        </TableContainer>

                    </>


                </main >
            }
        </AppBar >
    )
}

export default Dashboard